'use strict'
module.exports = {
  NODE_ENV: '"us"',

	// URLs
	APP_BASEURL: '"https://hermes.protopia.co/"',
	API_BASEURL: '"https://api.protopia.co/"',
	APP_REDIRECT_URL: '"https://protopia.co/maintenance"',
	CORE_API_URL: '"https://agw.protopia.co"',

	// Auth0
	AUTH0_DOMAIN: '"protopia.auth0.com"',
	AUTH0_CLIENT: '"6VWnX4xei7dl6dB5rt1g7hshRPK0LUQQ"',
	AUTH0_CALLBACK: '"https://hermes.protopia.co/callback"',

	// APIs
	NLP_API_KEY: '"AIzaSyAuG9BzAULL1S1BCYHCzOjUVraN7EVBXZQ"',

	// Branding
	LOGO_URL: '"https://storage.googleapis.com/protopia/logos/logo_protopia_xs.png"',

	// LinkedIn Integration
	LINKEDIN_CLIENT_ID: '"86bm0xpurfqdqb"',
	LINKEDIN_CLIENT_SECRET: '"i0MwVy2mRbdJk5E7"',
	LINKEDIN_REDIRECT_URI: '"https://hermes.protopia.co/thank-you"',
	LINKEDIN_STATE_KEY: '"PROTOPIA"',

	// App Settings
	DEFAULT_EMAIL: '"team@protopia.co"',
	RANDOM_INTEREST_COUNT: 15,
	ADDITIONAL_PARAM_FRIENDLY_COUNT: 12,
	APP_REDIRECT_TIME: 10000,
	CAPTCHA_SITEKEY: '6LfgdCMrAAAAAOhN7nO5JGf7RQuXgDCV_MmY4LSB',
  VUE_APP_PROCESS_DASHBOARD_URL:'"https://hermes.protopia.co/process-dashboard"',

	// Public base of the recruiting wizard.
	RECRUITING_BASEURL: '"https://opportunities.protopia.co"'
}



//////////////////
// WEBPACK FOOTER
// ./config/us.env.js
// module id = xUeO
// module chunks = 1